"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rfc = require("rfc6902");

var _oipRecord = _interopRequireDefault(require("../oip-record"));

var _decoders = require("../../../decoders");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EditRecord = /*#__PURE__*/function (_oipRecord$default) {
  _inherits(EditRecord, _oipRecord$default);

  var _super = _createSuper(EditRecord);

  function EditRecord(editRecordJSON, originalRecord, patchedRecord) {
    var _this;

    _classCallCheck(this, EditRecord);

    _this = _super.call(this);
    _this.oipRecordType = 'artifact'; // Define the edit information

    _this.edit = {
      txid: undefined,
      timestamp: undefined,
      patch: undefined
    };
    _this.meta = {
      applied: undefined
    };
    _this.signature = undefined;

    if (originalRecord) {
      _this.setOriginalRecord(originalRecord);
    }

    if (patchedRecord) {
      _this.setPatchedRecord(patchedRecord);
    }

    if (editRecordJSON) {
      _this.fromJSON(editRecordJSON);
    }

    return _this;
  }
  /**
   * Signs the PatchedRecord and EditRecord
   * @param  {Function} signMessage - A function (provided by a wallet) that allows a message to be signed with the approapriate private address
   * @return {Object} Returns `{success: true, signature}` if signing was successful
   */


  _createClass(EditRecord, [{
    key: "signSelf",
    value: function () {
      var _signSelf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signMessage) {
        var _this$getPatchedRecor, success, error, signature;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.getPatchedRecord()) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.getPatchedRecord().signSelf(signMessage);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", {
                  success: false,
                  error: "Unable to sign Patched Record: ".concat(_context.t0)
                });

              case 9:
                // Make sure the Record is valid
                _this$getPatchedRecor = this.getPatchedRecord().isValid(), success = _this$getPatchedRecor.success, error = _this$getPatchedRecor.error;

                if (success) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", {
                  success: false,
                  error: "Patched Record is not valid: ".concat(error)
                });

              case 12:
                // Now that we know the patched record is valid, create the latest patch version
                if (this.getOriginalRecord()) {
                  this.createPatch();
                }

              case 13:
                _context.prev = 13;
                _context.next = 16;
                return _oipRecord.default.prototype.signSelf.call(this, signMessage);

              case 16:
                signature = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t1 = _context["catch"](13);
                return _context.abrupt("return", {
                  success: false,
                  error: "Unable to create EditRecord signature: ".concat(_context.t1)
                });

              case 22:
                return _context.abrupt("return", {
                  success: true,
                  signature: signature
                });

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6], [13, 19]]);
      }));

      function signSelf(_x) {
        return _signSelf.apply(this, arguments);
      }

      return signSelf;
    }()
  }, {
    key: "setPatchedRecord",
    value: function setPatchedRecord(patchedRecord) {
      this.patchedRecord = patchedRecord;

      if (this.originalRecord) {
        // If the Patched Record has the same Timestamp as the Original Record, update it.
        if (this.getOriginalRecord().getTimestamp() === this.getPatchedRecord().getTimestamp()) {
          this.getPatchedRecord().setTimestamp(Date.now());
        }

        if (this.getOriginalRecord().getSignature() === this.getPatchedRecord().getSignature()) {
          this.getPatchedRecord().setSignature('');
        }

        this.createPatch();
      } else {
        this.setOriginalRecordTXID(patchedRecord.getOriginalTXID());
      }
    }
  }, {
    key: "setOriginalRecord",
    value: function setOriginalRecord(originalRecord) {
      this.originalRecord = originalRecord;
      this.setOriginalRecordTXID(originalRecord.getOriginalTXID());
    }
  }, {
    key: "setOriginalRecordTXID",
    value: function setOriginalRecordTXID(originalTXID) {
      this.edit.txid = originalTXID;
    }
  }, {
    key: "setTimestamp",
    value: function setTimestamp(timestamp) {
      this.edit.timestamp = timestamp;
    }
  }, {
    key: "setPatch",
    value: function setPatch(rfc6902Patch) {
      this.edit.patch = rfc6902Patch;

      if (this.originalRecord && !this.patchedRecord) {
        var patchedRecord = this.createPatchedRecord(this.originalRecord, this.edit.patch);
        this.setPatchedRecord(patchedRecord);
      }
    }
  }, {
    key: "setTXID",
    value: function setTXID(txid) {
      this.meta.txid = txid;
    }
  }, {
    key: "getPatchedRecord",
    value: function getPatchedRecord() {
      return this.patchedRecord;
    }
  }, {
    key: "getOriginalRecord",
    value: function getOriginalRecord() {
      return this.originalRecord;
    }
  }, {
    key: "getOriginalRecordTXID",
    value: function getOriginalRecordTXID() {
      return this.edit.txid;
    }
  }, {
    key: "getTimestamp",
    value: function getTimestamp() {
      return this.edit.timestamp;
    }
  }, {
    key: "getPatch",
    value: function getPatch() {
      return this.edit.patch;
    }
  }, {
    key: "getTXID",
    value: function getTXID() {
      return this.meta.txid;
    }
    /**
     * Apply an RFC6902 patch to an OIP Record
     * @param  {OIPRecord} originalRecord           - The Original Record
     * @param  {RFC6902PatchJSON} rfc6902Patch - The RFC6902 Patch JSON
     * @return {OIPRecord} Returns an OIP Record with the Edit Patch applied
     */

  }, {
    key: "createPatchedRecord",
    value: function createPatchedRecord(originalRecord, rfc6902Patch) {
      var clonedJSON = originalRecord.toJSON();
      var patchOperations = (0, _rfc.applyPatch)(clonedJSON.artifact, rfc6902Patch);

      var _iterator = _createForOfIteratorHelper(patchOperations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var op = _step.value;

          if (op !== null) {
            throw new Error('Patch Application had an Error! ' + JSON.stringify(patchOperations, null, 4));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var patchedRecord = (0, _decoders.decodeArtifact)(clonedJSON);
      this.setPatchedRecord(patchedRecord);
      return patchedRecord;
    }
    /**
     * Create an RFC6902 JSON Patch
     * @param  {Object} originalJSON
     * @param  {Object} modifiedJSON
     * @return {RFC6902PatchJSON} Returns the RFC6902 Patch JSON
     */

  }, {
    key: "createRFC6902Patch",
    value: function createRFC6902Patch(originalJSON, modifiedJSON) {
      this.rfc6902Patch = (0, _rfc.createPatch)(originalJSON, modifiedJSON);
      return this.rfc6902Patch;
    }
    /**
     * Create the RFC6902 Patch based on the Original Record and the Patched Record
     */

  }, {
    key: "createPatch",
    value: function createPatch() {
      // Verify that we have the Records we need
      if (!this.originalRecord || !this.patchedRecord) {
        throw new Error('Cannot create Patch without an Original Record and the Patched Record!');
      } // Create the rfc6902 JSON patch from the Record JSON


      var originalJSON = this.originalRecord.toJSON().artifact;
      var patchedJSON = this.patchedRecord.toJSON().artifact;
      this.rfc6902Patch = this.createRFC6902Patch(originalJSON, patchedJSON); // Set the RFC6902 Patch

      this.setPatch(this.rfc6902Patch);
    }
  }, {
    key: "createPreimage",
    value: function createPreimage() {
      this.preimage = "".concat(this.getOriginalRecordTXID(), "-").concat(this.getTimestamp());
      return this.preimage;
    }
    /**
     * Get the JSON version of the edit
     * @return {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var cloneJSON = JSON.parse(JSON.stringify({
        edit: this.edit,
        meta: this.meta
      }));
      return cloneJSON;
    }
    /**
     * Load an EditRecord from JSON
     * @param  {Object} editRecord - The Edit Record JSON
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(editRecord) {
      if (editRecord.edit) {
        if (editRecord.edit.txid) {
          this.setOriginalRecordTXID(editRecord.edit.txid);
        }

        if (editRecord.edit.timestamp) {
          this.setTimestamp(editRecord.edit.timestamp);
        }

        if (editRecord.edit.patch) {
          this.setPatch(editRecord.edit.patch);
        }
      }

      if (editRecord.signature) {
        this.signature = editRecord.signature;
      }

      if (editRecord.meta) {
        this.meta = editRecord.meta;
      }
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var serializedJSON = {};
      serializedJSON[this.oipRecordType] = this.edit;
      serializedJSON.signature = this.getSignature();
      return "json:".concat(JSON.stringify({
        oip042: {
          edit: serializedJSON
        }
      }));
    }
    /**
     * Get the Class Name.
     * @return {string} Returns "EditRecord"
     */

  }, {
    key: "getClassName",
    value: function getClassName() {
      return 'EditRecord';
    }
  }, {
    key: "isValid",
    value: function isValid() {
      if (!this.edit.txid || this.edit.txid === '') {
        return {
          success: false,
          error: 'Original Record TXID is a Required Field!'
        };
      }

      if (!this.edit.timestamp || this.edit.timestamp === '') {
        return {
          success: false,
          error: 'Having a timestamp is Required!'
        };
      }

      if (!this.edit.patch || this.edit.patch === '') {
        return {
          success: false,
          error: 'Having an Edit Patch is Required!'
        };
      } // Check if we only have [{ op: 'replace', path: '/timestamp', value: 123 }]


      var onlyReplace = true;
      var onlyTimestampAndSignature = true;

      var _iterator2 = _createForOfIteratorHelper(this.edit.patch),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var operation = _step2.value;

          if (operation.op !== 'replace') {
            onlyReplace = false;
          }

          if (operation.op === 'replace') {
            if (operation.path !== '/timestamp' && operation.path !== '/signature') {
              onlyTimestampAndSignature = false;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (JSON.stringify(this.edit.patch) === '{}' || onlyReplace && onlyTimestampAndSignature) {
        return {
          success: false,
          error: 'Empty Patch! You must modify the Record in order to edit it!'
        };
      }

      if (!this.signature || this.signature === '') {
        return {
          success: false,
          error: 'Having a Signature is Required!'
        };
      }

      return {
        success: true
      };
    }
  }]);

  return EditRecord;
}(_oipRecord.default);

exports.default = EditRecord;